import { Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({
  name: 'sentenceCase',
})
export class SentenceCasePipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(value[0], value[0]?.toUpperCase());
  }
}
